import { useQuery } from '@tanstack/react-query';
import { getClinicById } from '../../../../apis/clinics/requests';

const useClinicById = (clinicId: string) => {
  const { data, isLoading } = useQuery({
    queryFn: () => getClinicById(clinicId),
    queryKey: ['clinic', clinicId]
  });

  return { clinic: data, isLoading };
};

export default useClinicById;
